<template>
  <section class="change-password-content">
    <div class="main">
      <div class="loginlogo"><img src="../img/ico.png" width="80px"/></div>
      <div class="first">
        <div v-show="!reset_pw" class="oldpass">
          <input type="password" v-model="pwd" @keypress.enter="submit" placeholder="Old Password"/>
        </div>
        <div class="newpass">
          <input type="password" v-model="new_pwd" @keypress.enter="submit" placeholder="New Password"/>
        </div>
        <div class="confirmpass">
          <input type="password" v-model="new_pwd_ag" @keypress.enter="submit" placeholder="Confirm New Password"/>
        </div>
        <div class="buttons">
          <div class="error">{{msg}}</div>
          <button class="btn btn-outline-primary" @click="submit">{{submit_}}</button>
          <button class="btn btn-outline-primary" @click="reset">{{reset_}}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { hash } from '@/utils'
  import { passwd } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        reset_pw: false,
        pwd: '',
        new_pwd: '',
        new_pwd_ag: '',
        msg: '',
        username: ''
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale']),
      ...mapGetters([]),
      ...i18n.map([
        'changePassword_', 'password_', 'newPwd_',
        'retypePwd_', 'submit_', 'reset_', 'notMatch_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      submit () {
        if (this.new_pwd !== this.new_pwd_ag) {
          this.$emit('msg', {
            msg: notMatch_,
            type: 'error',
            delay: 2000
          })
          return
        }

        let oldpass = ''
        if (this.reset_pw) oldpass = this.$route.query.token
        else oldpass = hash(this.username, this.pwd)

        passwd(this.username, oldpass, hash(this.username, this.new_pwd))
          .then((data) => {
            this.$emit('msg', {
              msg: data.msg,
              type: 'info',
              delay: 2000,
              callback: () => {
                this.profile.name = this.profile.name || this.username
                this.$router.push('/profile')
              }
            })
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      reset () {
        this.pwd = ''
        this.new_pwd = ''
        this.new_pwd_ag = ''
      }
    },
    created () {
      let {name, token} = this.$route.query
      if (name && token) {
        this.reset_pw = true
      } else name = this.profile.uid
      if (!name) {
        this.$router.replace('/login')
        return
      }

      this.username = name
    }
  }
</script>

<style lang="less" scoped>
.change-password-content {
    .main {
        .loginlogo{
          text-align: center;
          margin-top: 100px;
          > img {
            width: 150px;
          }
        }
        .first {
            .oldpass::before{
              content: '';
              background: url('../img/oldpassword.png') no-repeat bottom left /28px;
              position: absolute;
              margin-top: 15px;
              margin-left: 5px;
              z-index: 2;
              width: 32px;
              height: 40px;
            }
            .newpass::before{
              content: '';
              background: url('../img/password.png') no-repeat bottom left /28px;
              position: absolute;
              margin-top: 15px;
              margin-left: 5px;
              z-index: 2;
              width: 32px;
              height: 40px;
            }
            .confirmpass::before{
              content: '';
              background: url('../img/confirmPassword.png') no-repeat bottom left /28px;
              position: absolute;
              margin-top: 15px;
              margin-left: 5px;
              z-index: 2;
              width: 32px;
              height: 40px;
            }
            div {
                width: 500px;
                input {
                  color: #fff;
                  font-family: 'Courier';
                  height: 60px;
                  width: 498px;
                  padding-left: 50px;
                  border: none;
                  outline: none;
                  background: none;
                  border-bottom: 1px solid #fff;
                }
                &.buttons {
                    .btn{
                      width: 150px;
                      color: #00c8e3;
                      font-size: 18px;
                      height: 45px;
                      background: transparent;
                      margin-left: 75px;
                    }
                  .error {
                    margin-top: 0px;
                    height: 55px;
                    line-height: 35px;
                    color: #a94442;
                  }
                    .btn:last-child {
                        margin-left: 30px;
                    }
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/themes/dragon/components/change_pwd.vue